export const SN_MAARGJOB = 'maargJob'
export const MAARGJOB_UPDATED_BULK = SN_MAARGJOB + '/UPDATED_BULK'
export const MAARGJOB_UPDATED = SN_MAARGJOB + '/MAARG_JOBS_UPDATED'
export const MAARGJOB_CURRENT_UPDATED = SN_MAARGJOB + '/CURRENT_JOB_UPDATED'

